module.exports = __webpack_public_path__ + "static/media/4.897c237a.jpg";